import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import "../css/about.css";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";

function About() {
	const { state } = useLocation();
	const navigate = useNavigate();
	useEffect(() => {
		if (
			process.env.NODE_ENV !== "development" &&
			(!state ||
				state === null ||
				state === undefined ||
				!state.has_access)
		) {
			navigate("/visit");
		}
	});
	return (
		<div>
			<div>
				<Header />
				<div
					className="home-top-container"
					style={{ paddingBottom: "0px" }}
				>
					<div
						className="toc-title"
						style={{
							marginRight: "auto",
							marginLeft: "calc(15% / 2)",
						}}
					>
						Welsh Housing Quality Standard 2023 & Optimised Retrofit Programme - Theory of Change
					</div>
					<div className="filters-container">
						<div className="home-top-subcontainer">
							<div
								className="home-clear-button-container"
								style={{ marginRight: "auto" }}
							>
								<button
									onClick={() =>
										navigate("/", {
											state: { has_access: true },
										})
									}
									style={{
										display: "flex",
										alignItems: "center",
										flexWrap: "wrap",
										justifyContent: "center",
										color: "white",
									}}
								>
									<span style={{ marginRight: "5px" }}>
										View Diagram
									</span>{" "}
									<ArrowForward />
								</button>
							</div>
						</div>
					</div>
				</div>
				<div className="home-container">
					<p>
						A Theory of Change (ToC) is a framework used to demonstrate how a given policy, intervention or programme leads to change. It sets out how the resources invested (that is, inputs) and activities results into immediate products (outputs), which in turn are able to achieve policy objectives (outcomes and impacts). Both the Welsh Housing Quality Standard 2023 and the Optimised Retrofit Programme Theories of Change of Change are granular, mapping activities, outputs and wider impacts of each specific programme.  
					</p>
					<p>
						In particular, the ToC framework links pilot activities
						(that is, inputs) to outputs, outcomes, and impact
						defined as follows:
						<ol type="i">
							<li>
								<b style={{ color: "var(--primary-color)" }}>
									{" "}
									inputs
								</b>{" "}
								refer to each programme respectively (WHQS 2023 & ORP);
							</li>
							<li>
								<b style={{ color: "var(--primary-color)" }}>
									{" "}
									outputs
								</b>{" "}
								represent the immediate products of inputs;
							</li>
							<li>
								<b style={{ color: "var(--primary-color)" }}>
									{" "}
									outcomes
								</b>{" "}
								are changes in key areas of interest resulting from outputs which are expected to materialise over time; 
							</li>
							<li>
								<b style={{ color: "var(--primary-color)" }}>
									{" "}
									impact
								</b>{" "}
								refers to long term goals, generated from the shorter in term outcomes.       
							</li>
						</ol>
					</p>

					<p className="download-excel-container">
						You can click the links below to download the Theory of
						Change diagram in a spreadsheet format:
						<ul class="dashed">
							<li>
								<a
									className="download-link"
									href={`${process.env.REACT_APP_API_URL}/download_current_data/`}
								>
									Current Data
								</a>
							</li>
							<li>
								<a
									className="download-link"
									href={`${process.env.REACT_APP_API_URL}/download_initial_data/`}
								>
									Initial Research Data
								</a>
							</li>
						</ul>
					</p>

					<p className="upload-excel-container">
						If you have administrator rights, you can change the
						current data by uploading an updated version of the
						above spreadsheets{" "}
						<a
							className="upload-link"
							href={`${process.env.REACT_APP_API_URL}/upload_data/`}
							target="_blank"
							rel="noopener noreferrer"
						>
							here
						</a>
						.
					</p>
					<br />
					<p id="table_title">
						Definitions of filters incorporated in the Theory of
						Change
					</p>
					<table className="styled-table">
						<thead>
							<tr>
								<th style={{ width: "110px" }}>Filter type</th>
								<th style={{ width: "300px" }}>Category</th>
								<th>Definition</th>
							</tr>
						</thead>
						<tbody>
							<tr className="pillar">
								<td>Programme</td>
								<td>Welsh Housing Quality Standard 2023</td>
								<td>
									Initiatives derived from the framework of WHQS 2023.
								</td>
							</tr>
							<tr className="pillar">
								<td>Programme</td>
								<td>Optimised Retrofit Programme 3</td>
								<td>
									Initiatives that involve claiming and executing the works under the Optimised Retrofit Programme.
								</td>
							</tr>
						</tbody>
					</table>
					<p>
						<b>Note:</b> Multiple lines for one activity indicate that it has multiple impact chains. For example, improving housing energy efficiency can both enhance residents' financial well-being and reduce the carbon footprint of homes.
					</p>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default About;
